import { IoMdAddCircle, IoIosWarning } from "react-icons/io";


export const getDisplayTitle = (title,priorite) => {
    if(priorite === 1) {

    }
    if (!title) return ""; // Handle null/undefined cases
    
    // Split title by ' - '
    const parts = title.split(' - ');
    
    let newTitle = "";
    // Get the last meaningful part (ignoring RELANCE and numbers)
    for (let i = 0; i <= parts.length - 1; i++) {
      const part = parts[i].trim();
      
      // Skip if part is empty
      if (!part) continue;
      
      // Skip if part is just RELANCE with optional date
      if (part.includes("RELANCE")) continue;
      
      // Skip if part contains only numbers (with optional +)
      if (/^[\d+]+$/.test(part.replace(/\s/g, ''))) continue;
      
      newTitle += part;

      newTitle += " - "; // Add separator for next part
      
    }
    // enlever le dernier " - "
    newTitle = newTitle.slice(0, -3);
    return newTitle; // Return original title if no valid part found
  };